<template>
  <div id="sendCoupons20210604">
          <el-dialog
                title="发券详情"
                :visible.sync="show"
                :modal-append-to-body="false"
                append-to-body
                :close-on-click-modal="false"
                width="80%"
                >

                <el-form :inline="true" ref="query" :model="query">
                <el-row>
                        <el-col span="7" style="padding-left: 10px;">
                        <el-form-item label="优惠券名称" prop="couponId">
                                <el-select
                                v-model="query.couponId"
                                style="width: 100%; "
                                placeholder="请选择优惠券"
                                clearable
                                filterable
                                size="small"
                                >
                                <el-option
                                        v-for="item in querycouponsList"
                                        :key="item.id"
                                        :label="item.couponName"
                                        :value="item.id"
                                >
                                </el-option>
                                </el-select>
                        </el-form-item>
                        </el-col>

                        <el-col span="6">
                        <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="search">搜 索</el-button>
                        <!-- <el-button type="default" size="small" icon="el-icon-delete" @click="searchReset">重 置</el-button> -->
                        </el-form-item>
                        </el-col>
                </el-row>
                </el-form>
                <avue-crud :option="option"
                        :table-loading="loading"
                        :data="data"
                        :page.sync="page"
                        :permission="permissionList"
                        v-model="form"
                        ref="crud"
                        @search-change="searchChange"
                        @search-reset="searchReset"
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        @refresh-change="onLoad"
                        @on-load="onLoad">
                        <template slot="menuLeft">
                                <el-button type="primary" size="small" icon="el-icon-plus" @click="openCouponShopcouponsShow('add')"
                                >发 券
                                </el-button>
                        </template>
                        <template slot-scope="scope" slot="menu">
                                <el-button
                                type="text"
                                size="small"
                                icon="el-icon-edit"
                        
                                @click="openCouponShopcouponsShow('edit',scope.row)"
                                >编辑</el-button>
                        </template>
                </avue-crud>
                <el-dialog
                        :title="title"
                        :visible.sync="couponShopcouponsShow"
                        :modal-append-to-body="false"
                        append-to-body
                        @close="couponShopEditDialogClose"
                        width="50%"
                        >
                        <div>
                                <el-form ref="sendCouponsFrom"  :model="sendCouponsFrom" label-width="120px">
                                <el-row>
                                        <el-col span="12" style="padding-left: 10px;">
                                        <el-form-item 
                                                label="车场名称" 
                                                required
                                                prop="parkingLotId"
                                                :rules="[{ required: true, message: '请选择车场', trigger: 'change' }]"
                                        >
                                                <el-select
                                                v-model="sendCouponsFrom.parkingLotId"
                                                style="width: 100%; "
                                                @change="changeParkingLotList"
                                                placeholder="请选择车场"
                                                disabled
                                                size="small"
                                                >
                                                <el-option
                                                        v-for="item in parkingLotList"
                                                        :key="item.id"
                                                        :label="item.title"
                                                        :value="item.id"
                                                >
                                                </el-option>
                                                </el-select>
                                                </el-form-item>
                                        </el-col>
                                </el-row>
                                <h3>优惠券新增</h3>
                                <el-row gutter="0" v-for="(item,index) in sendCouponsTypeAndNumList" :key="index">
                                        
                                        <el-col span="10" >
                                                <el-form-item label="优惠券名称" :required="true">
                                                <el-select
                                                        v-model="item.couponId"
                                                        style="width: 100%; "
                                                        placeholder="请选择优惠券"
                                                        size="small"
                                                        :disabled="title=='编辑'"
                                                        >
                                                        <el-option
                                                                v-for="item in couponsList"
                                                                :key="item.id"
                                                                :label="item.couponName"
                                                                :value="item.id"
                                                        >
                                                        </el-option>
                                                </el-select>
                                                </el-form-item>
                                        </el-col>
                                        <el-col span="8" >
                                                <el-form-item label="数量" :required="true" label-width="70px">
                                               <el-input 
                                                        v-model="item.num" 
                                                        maxlength="9" 
                                                        show-word-limit
                                                        @input="e=>inputCouponNum(e,index)"
                                               >

                                               </el-input>
                                               </el-form-item>
                                        </el-col>
                                        <el-col span="6" >
                                                <el-form-item label-width="20px" v-if="title=='新增'">
                                                        <el-button type="danger" icon="el-icon-minus" circle
                                                                @click="delSendCouponsTypeAndNum(index)"
                                                        ></el-button>
                                                        <el-button type="success" icon="el-icon-plus" circle
                                                                @click="addSendCouponsTypeAndNum"
                                                        ></el-button>
                                                </el-form-item>
                                        </el-col>
                                        
                                </el-row>
                                <el-row>
                                        <el-col offset="6">
                                                <el-form-item label-width="70px">
                                                        <el-button type="primary" icon="el-icon-search" @click="addSendCoupons">保存</el-button>
                                                        <el-button type="default" icon="el-icon-delete" @click="couponShopcouponsShow = false">返回</el-button>
                                                </el-form-item>
                                        </el-col>
                                </el-row>
                                </el-form>
                        </div>
                </el-dialog>
        </el-dialog>
  </div>
</template>

<script>
  import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
  import {
    selectionList,
    getCouponsDetailsPage,
    couponsDetailssave,
    couponsDetailsUpdate
  } from '@/api/v4ward/park/coupon/shop/carcouponshop';

  export default {
    data() {

      // 手机号验证
      var checkPhone = (rule, value, callback) => {
        const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/;
        if (!value) {
          return callback(new Error('电话号码不能为空'));
        }
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error('电话号码格式不正确'));
          }
        }
      };

      // 0-100数值校验
      var checkNum = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('百分比不能为空'));
        }
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value < 0 || value > 100) {
            callback(new Error('请输入0-100数值'));
          } else {
            callback();
          }
        }
      };
      return {
        query: {
          couponId: '',
          shopId:'',
          parkingLotId:'',
        },
        title:'新增',
        disabled:false,
        parkingLotList: [],
        shopUseList: [],
        shopNotifyMethodList: [],
        //新增
        couponShopAddShow: false,
        // 新增表单数据
        sendCouponsFrom: {
          parkingLotId: '',
          
        },
        // 新增类型数量集合
        sendCouponsTypeAndNumList:[
                {
                        couponId:'',
                        num:'',
                        parkingLotId:'',
                }
        ],
        couponsList:[],//优惠券list
        querycouponsList:[],//优惠券list
       
        // 新增
        couponShopcouponsShow:false,
        //编辑
        couponShopEditShow: false,
        show:false,
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        selectionList: [],
        option: {
          align: 'center',
          height: 'auto',
          calcHeight: 30,
          tip: false,
          addBtn:false,
          searchShow: true,
          searchMenuSpan: 4,
          border: true,
          index: true,
          viewBtn:false,
          editBtn:false,
          delBtn:false,
          indexLabel: '序号',
          viewBtn: false,
          dialogClickModal: false,
          column: [
            {
              label: '车场名称',
              prop: 'parkingLotId',
              props: {
                label: 'title',
                value: 'id',
                disabled: 'disabled',
              },
              type: 'tree',
              dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
              rules: [{
                required: true,
                message: '请输入停车场ID',
                trigger: 'change',
              }],
            },
            {
              label: '商家名称',
              prop: 'shopName',
              rules: [{
                required: true,
                message: '请输入商家名称',
                trigger: 'change',
              }],
            },
            {
              label: '优惠券名称',
              prop: 'couponName',
             
            },
            {
              label: '数量',
              prop: 'num',
              
            },

            {
              label: '发券时间',
              prop: 'createTime',
            },
            {
              label: '发券人',
              prop: 'sendName',
            },
            
            
          ],
        },
        onLoadFlage:true,//onload开关
        data: [],
      };
    },
    activated() {
      let self = this;
      setTimeout(() => {
        this.$refs.crud.doLayout(); //解决表格错位
      }, 0);
    },
//     mounted(){
//         setTimeout(() => {
//                 this.$refs.crud.doLayout(); //解决表格错位
//         }, 0);
//     },
    computed: {
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    methods: {
        //     新增新增
        addSendCoupons(type){
                this.$refs.sendCouponsFrom.validate((valid) => {
                        if (valid) {
                                let numFlag = false;
                                let couponsFlag = false;
                                
                                this.sendCouponsFrom.carCouponShopRecordList = [];
                                this.sendCouponsTypeAndNumList.forEach(ele=>{
                                         this.sendCouponsFrom.carCouponShopRecordList.push(ele);
                                        if(!ele.couponId){
                                                couponsFlag = true;
                                        }
                                        if(!ele.num){
                                                numFlag = true
                                        }
                                })
                                if(couponsFlag){
                                        this.$message.warning('请选择优惠券后再添加');
                                        return
                                }
                                if(numFlag){
                                        this.$message.warning('请输入数量后再添加');
                                        return
                                }
                                console.log(this.sendCouponsFrom)
                                this.sendCouponsFrom.shopId = this.query.shopId;
                                if(this.title=='新增'){
                                        couponsDetailssave(this.sendCouponsFrom).then(() => {
                                                this.couponShopcouponsShow = false;
                                                this.onLoad();
                                                this.$message.success('操作成功!');
                                        }, error => {
                                                window.console.log(error);
                                                // loading();
                                        });
                                }else{
                                        // this.sendCouponsFrom.couponId = this.sendCouponsTypeAndNumList[0].couponId;
                                        this.sendCouponsFrom.num = this.sendCouponsTypeAndNumList[0].num;
                                        let form = {
                                                id:this.sendCouponsFrom.id,
                                                num:this.sendCouponsFrom.num,
                                        }
                                        couponsDetailsUpdate(form).then(() => {
                                                this.couponShopcouponsShow = false;
                                                this.onLoad();
                                                this.$message.success('操作成功!');
                                        }, error => {
                                                window.console.log(error);
                                                // loading();
                                        });
                                }
                                
                        } else {
                                console.log('error submit!!');
                                return false;
                        }
                });
                
        },
        // 输入数量校验
        inputCouponNum(e,index){
                let value = this.omitNumber(e);
                this.sendCouponsTypeAndNumList[index].num = value;
                this.$forceUpdate();
        },
        omitNumber(e){
                let value = e;
                value = value.replace(/[^\d]/g, ""); //清除“数字”和“.”以外的字符
                value = value.replace(/\.{1,}/g, ""); //只保留第一个. 清除多余的
                value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
                if (value.indexOf(".") < 0 && value != "") {
                        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                        value = parseFloat(value);
                }
                if(value=='.'){
                value = '0.'
                }
                return value;
        },
        //     打开新增详情页面弹窗 总的
        openDialog(data){
                this.show = true;
                this.query.parkingLotId = data.parkingLotId;
                this.query.shopId = data.shopId;
                this.onLoadFlage = false;
                this.onLoad();
                this.initData(data)
                setTimeout(() => {
                        this.$refs.crud.doLayout(); //解决表格错位
                }, 0);
        },
        //     初始化数据
        async initData(data){
                await getSpaceTree().then((data) => {
                this.parkingLotList = data.data;
                        if (this.parkingLotList.length > 0) {
                                
                               
                        }
                });
                await selectionList({parkingLotId:data.parkingLotId}).then(res=>{
                        // this.query.couponId = res.data[0].id;
                        this.couponsList = res.data;
                        this.querycouponsList = res.data;
                })
        

        },
        // 减少新增集合
        delSendCouponsTypeAndNum(index){
               
                let temArr = [];
                this.sendCouponsTypeAndNumList.forEach((ele,i)=>{
                        if(i!=index){
                              temArr.push(ele)  
                        }
                })
                this.sendCouponsTypeAndNumList = temArr;
        },
        //     新增新增类型 集合
        addSendCouponsTypeAndNum(){
                let numFlag = false;
                let couponsFlag = false;
                this.sendCouponsTypeAndNumList.forEach(ele=>{
                        if(!ele.couponId){
                                couponsFlag = true;
                        }
                        if(!ele.num){
                                numFlag = true
                        }
                })
                if(couponsFlag){
                        this.$message.warning('请选择优惠券后再添加');
                        return
                }
                if(numFlag){
                        this.$message.warning('请输入数量后再添加');
                        return
                }
                this.sendCouponsTypeAndNumList.push({couponId:'',num:''})
        },
        //切换车厂 优惠券名称变换
        changeParkingLotList(e){
                this.sendCouponsTypeAndNumList = [{
                        couponId:'',
                        num:'',
                }]
                selectionList({parkingLotId:e}).then(res=>{
                        this.couponsList = res.data;
                })
        },
        //     打开新增弹窗 新增 编辑
        openCouponShopcouponsShow(type,row){
                if(type=='add'){
                         this.title = "新增";
                        this.sendCouponsFrom = {
                                parkingLotId : this.query.parkingLotId,
                        };
                        this.sendCouponsTypeAndNumList = [{couponId:'',num:''}];
                        selectionList({parkingLotId:this.sendCouponsFrom.parkingLotId}).then(res=>{
                                this.couponsList = res.data;
                        })
                        this.couponShopcouponsShow = true;
                }else{
                        this.title = "编辑";
                        this.sendCouponsFrom = row;
                        // this.sendCouponsFrom = {
                        //         parkingLotId : this.parkingLotList[0].id,
                        // };
                        this.sendCouponsFrom.couponId = row.couponName;
                        this.sendCouponsTypeAndNumList = [{couponId:row.couponId,num:row.num}];
                        selectionList({parkingLotId:this.sendCouponsFrom.parkingLotId}).then(res=>{
                                this.couponsList = res.data;
                        })
                        this.couponShopcouponsShow = true;
                }
               
        },
      searchReset() {
        if (this.querycouponsList.length > 0) {
          this.query.couponId = this.querycouponsList[0].id;
        }
        this.onLoad();
      },
      search(){
        this.page.currentPage = 1;
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        if(this.onLoadFlage){
                return
        }
        this.loading = false;
        if(this.query.parkingLotId == ""){
          return;
        }
        page = page || this.page;
        this.loading = true;
        getCouponsDetailsPage(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query),
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }).catch(err=>{
                this.loading = false;
        })
      },

 


    
    

    },
  };
</script>

<style>
#sendCoupons20210604 .el-form-item__content{
        line-height: 32px !important;
}
</style>
